export default "__VITE_ASSET__yLM9eyWC__"